import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { BadgeIndianRupee, Building2, Scale, ArrowRight } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

const ICON_MAP = { BadgeIndianRupee, Building2, Scale };

export const ServiceCard = ({ service }) => {
  const Icon = ICON_MAP[service.icon];

  return (
    <Card
      className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden bg-white"
      data-testid={`service-card-${service.id}`}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-4 left-4">
          <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-lg">
            {Icon && <Icon className="w-6 h-6 text-cyan-600" />}
          </div>
        </div>
      </div>

      <CardHeader>
        <CardTitle className="text-2xl text-gray-900 group-hover:text-cyan-600 transition-colors">
          {service.title}
        </CardTitle>
        <CardDescription className="text-gray-600 text-base">
          {service.description}
        </CardDescription>
      </CardHeader>

      <CardContent>
        <ul className="space-y-3">
          {service.features.map((feature) => (
            <li key={`${service.id}-${feature}`} className="flex items-start text-gray-700">
              <ArrowRight className="w-4 h-4 text-cyan-500 mr-2 mt-1 flex-shrink-0" />
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>

        <Button
          variant="ghost"
          onClick={() => trackEvent('service_view', { event_category: 'Services', event_label: service.title })}
          className="w-full mt-6 text-cyan-600 hover:text-cyan-700 hover:bg-cyan-50 group/btn"
          data-testid={`service-learn-more-${service.id}`}
        >
          Learn More
          <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
